import '../../node_modules/select2/dist/js/select2.min.js';
import '../../node_modules/magnific-popup/dist/jquery.magnific-popup.js';
import '../../node_modules/jquery-lazy/jquery.lazy';
require('../../node_modules/jquery-mousewheel/jquery.mousewheel.js');
require('../../node_modules/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.js');

let $body = $('body');

export let ui;
ui = {

    /**
     * Lazy load image
     */
    initLazyLoadImg() {
        $('.js_lazy-img-bg').lazy()
        $('.js_lazy-img').lazy({
            effect:'fadeIn'
        })
    },

    /**
     * Scroll to the top of the site
     *
     * @param el - button which you click on to scroll up.
     */

    addScrollClass(el){
        $(window).scroll(function() {
            if ($(window).scrollTop() > 50) {
                $(el).fadeIn(400)
            }
            else{
                $(el).fadeOut(400)
            }
        })
        $body.on('click', el, function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $body.offset().top - 100
            }, 500)
        })
    },

    /**
     * Init select2
     * @param el
     */
    initDefaultSelect(el) {
        $(el).each(function(){
            let $thisSelect = $(this)
            $thisSelect.select2({
                minimumResultsForSearch: Infinity,
                dropdownParent: $thisSelect.parent()
            }).on('select2:open', () => {
                $('.select2-results__options').mCustomScrollbar('destroy')
                setTimeout(() => {
                    $('.select2-results__options').mCustomScrollbar()
                }, 0)
            })
        })
    },

    /**
     * Init accordion
     * @param accordionTtl
     * @param accordionCnt
     * @param activeClassTtl
     */
    accordion(accordionTtl, accordionCnt, activeClassTtl ){
        $body.on('click', accordionTtl, function (event) {
            event.preventDefault()
            $(this).toggleClass(activeClassTtl)
            $(this).next(accordionCnt).slideToggle(400)
        })
    },

    openFilter(btn, filterBlk) {
        $body.on('click', btn, function(e) {
            e.preventDefault()
            $('html, body').animate({
                scrollTop: $body.offset().top - 100
            }, 0)
            $(this).addClass('__active')
            $('.js_open-sort').removeClass('__active')
            $body.addClass('__show-open')
            $body.addClass('__overlay')
            $('.js_accordion-ttl').each((i, el) => {
                $(el).addClass('__active')
            })
            $('.js_accordion-cnt').each((i, el) => {
                $(el).slideUp()
            })
            $('.js_sort').slideUp(400)
            $(filterBlk).slideDown(400)
        });
    },

    closeFilter(btn, filterBlk) {
        $body.on('click', btn, function(e) {
            e.preventDefault()
            $('.js_open-filter').removeClass('__active')
            $('.js_open-sort').removeClass('__active')
            $body.removeClass('__overlay')
            $body.removeClass('__show-open')
            $(filterBlk).removeClass('__open')
            $(filterBlk).slideUp(400)
        })
    },

    openSort(btn, sortBlk) {
        $body.on('click', btn, function(e) {
            e.preventDefault()
            $('html, body').animate({
                scrollTop: $body.offset().top - 100
            }, 0)
            $(this).addClass('__active')
            $('.js_open-filter').removeClass('__active')
            $body.addClass('__overlay')
            $body.removeClass('__show-open')
            $('.js_filter').slideUp(400)
            $(sortBlk).slideDown(400)
        })
    },

    /**
     * Open popup
     *@param el - class of the element
     */
    popupForm(el) {
        $body.on('click', el, function(e) {
            e.preventDefault()
            let $el = $(this)
            let modalEL = $el.attr('href')
            ui.openPopup(modalEL)
        })
    },

    /**
     * Open popup
     * @param modalEL
     */
    openPopup(modalEL) {
        $.magnificPopup.open({
            showCloseBtn: false,
            type: 'inline',
            tLoading: 'Загрузка...',
            items: {
                src: modalEL
            }
        })
    },

    /**
     * Close popup
     * @param el
     */
    closePopup(el) {
        $body.on('click', el, function(e) {
            e.preventDefault();
            $.magnificPopup.close()
        })
    },

    /**
     * Style scroll
     * @param el
     */
    initScrollStyle(el) {
        if($(el).length === 0) return
        $(el).mCustomScrollbar({
            theme: 'dark',
            advanced:{
                updateOnContentResize: true,
            }
        });
    },

    /**
     * Show more text
     * @param btn
     * @param blk
     */
    showMore(btn, blk) {
        if ($(blk).height() > 110) {
            $(blk).addClass('__less')
            $(btn).removeClass('__hidden')
        }
        $body.on('click', btn, function(e) {
            e.preventDefault()
            $(this).toggleClass('__active')
            $(blk).toggleClass('__less')
        })
    },
};
